import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import { getText, requestThunk, ServerError } from "swiipe.portal.shared"
import { endpoints } from "../../data/endpoints"
import { StoreState } from "../StoreState"
import { getGatewaysForMerchantThunk } from "./gatewayThunks"
import { addModalThunk } from "./modalThunks"
import { getOnboardingStatusThunk } from "./swiipePaymentsThunks"
import { sendServiceConfirmationEmailThunk } from "./swiipeServicesThunks"

export const vippsDisableOnboardingThunk =
    (swMerchantId: string, webshopId: string, gatewayId: string): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch) => {
        await dispatch(
            requestThunk(endpoints.Payments.patchGateway(gatewayId), {
                data: {
                    webshopId,
                    paymentType: "Vipps",
                    enabled: false,
                },
            })
        )

        await dispatch(getGatewaysForMerchantThunk(swMerchantId, true))
        await dispatch(getOnboardingStatusThunk(swMerchantId, webshopId, true, ["Vipps"]))
    }

export interface IVippsGetOnboardingDataResponse {
    msn: string
}

export const getVippsOnboardingDataThunk =
    (webshopId: string): ThunkAction<Promise<IVippsGetOnboardingDataResponse>, StoreState, null, AnyAction> =>
    async (dispatch) => {
        return await dispatch(
            requestThunk<IVippsGetOnboardingDataResponse>(endpoints.VippsMobilePay.getOnboardingData, {
                params: {
                    webshopId: webshopId,
                },
            })
        )
    }

export interface IVippsOnboardingConnectData {
    swMerchantId: string
    webshopId: string
    clientId: string
    clientSecret: string
    subscriptionKey: string
    msn: string
}

export const vippsOnboardingConnectThunk =
    (data: IVippsOnboardingConnectData): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(
            requestThunk(
                endpoints.VippsMobilePay.onboardConnect,
                {
                    data: data,
                },
                {
                    errorHandlers: [
                        {
                            errorType: "ApiKeyInvalidError",
                            handleError: async (error: ServerError) => {
                                await dispatch(
                                    addModalThunk({
                                        type: "error",
                                        errorMessage: getText("vippsonboarding.onboardingInvalid"),
                                    })
                                )
                                return true
                            },
                        },
                    ],
                }
            )
        )

        await dispatch(
            sendServiceConfirmationEmailThunk(data.swMerchantId, "VippsEpaymentConfirmation", getText("serviceNames.vipps"))
        )

        await dispatch(getGatewaysForMerchantThunk(data.swMerchantId, true))
        await dispatch(getOnboardingStatusThunk(data.swMerchantId, data.webshopId, true, ["Vipps"]))
    }
